
/**
 * Utility functions to handle redirect URLs after authentication
 */

// Key used for storing the redirect URL in localStorage
const REDIRECT_URL_KEY = 'auth_redirect_url';

/**
 * Stores the current URL path for redirection after authentication
 * @param url - The URL to redirect to after authentication
 */
export const storeRedirectUrl = (url: string): void => {
  if (url && !url.includes('/auth')) {
    localStorage.setItem(REDIRECT_URL_KEY, url);
  }
};

/**
 * Retrieves the stored redirect URL
 * @returns The stored redirect URL or null if not found
 */
export const getRedirectUrl = (): string | null => {
  return localStorage.getItem(REDIRECT_URL_KEY);
};

/**
 * Clears the stored redirect URL
 */
export const clearRedirectUrl = (): void => {
  localStorage.removeItem(REDIRECT_URL_KEY);
};

/**
 * Gets and clears the redirect URL in one operation
 * @returns The stored redirect URL or null if not found
 */
export const getAndClearRedirectUrl = (): string | null => {
  const url = getRedirectUrl();
  clearRedirectUrl();
  return url;
};
